module.exports = __webpack_public_path__ + "img/icon2.77cf0c0e.png";